// How many API requests are in flight, for the activity bar at the top of the page (components/ActivityBar.js).
// src/services/api.js counts every request except those made with { silent: true } — the background polls (the
// approvals bell, the WhatsApp badge, a list refreshing itself), which would otherwise flash the bar every few seconds.
let inFlight = 0;
const listeners = new Set();
const notify = () => listeners.forEach(fn => fn(inFlight));

export const requestStarted = () => { inFlight += 1; notify(); };
export const requestEnded = () => { inFlight = Math.max(0, inFlight - 1); notify(); };
export const subscribeActivity = (fn) => { listeners.add(fn); fn(inFlight); return () => listeners.delete(fn); };
